var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_AS_POWER_USER, SET_USER_TYPE } from "../actions/user";
var initialState = {
    pmUser: false,
    powerUser: false
};
var userReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_USER_TYPE:
            return __assign(__assign({}, state), { pmUser: action.payload.profile.directory === 'TPNYC' });
        case SET_AS_POWER_USER:
            return __assign(__assign({}, state), { powerUser: action.payload });
        default:
            return state;
    }
};
export default userReducer;
